var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 107,
    viewBox: "0 0 91 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1237 1.39355C81.7586 1.39355 89.5693 9.1688 89.5693 18.7601C89.5693 28.3513 81.7586 36.1266 72.1237 36.1266C67.2587 36.1266 62.862 34.1432 59.7012 30.9522L35.5509 47.3949C35.7739 48.5046 35.8911 49.6508 35.8911 50.8215C35.8911 53.1399 35.4327 55.3562 34.6021 57.3819L61.0829 74.78C64.0885 72.3329 67.9339 70.8595 72.1237 70.8595C81.7586 70.8595 89.5693 78.6349 89.5693 88.2264C89.5693 97.8174 81.7586 105.593 72.1237 105.593C62.489 105.593 54.6782 97.8174 54.6782 88.2264C54.6782 85.7142 55.2159 83.3228 56.1823 81.1638L29.9157 63.9063C26.8516 66.5691 22.8381 68.1879 18.4454 68.1879C8.81058 68.1879 1 60.4125 1 50.8215C1 41.2301 8.81058 33.4549 18.4454 33.4549C23.9859 33.4549 28.9178 36.0255 32.111 40.0263L55.5166 24.0903C54.972 22.4085 54.6782 20.6162 54.6782 18.7601C54.6782 9.1688 62.489 1.39355 72.1237 1.39355V1.39355Z",
    fill: "#5763F3",
    stroke: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.cf359a011555b95506c5a4b02e32e12e.svg";
export { ForwardRef as ReactComponent };